import { useRef, memo, useMemo, useCallback, useState, useEffect } from "react";
import { useAuth } from "src/contexts/auth";
import Map from 'devextreme-react/map';
import { fetchWithToken, endpointPath } from "src/hooks/useFetch";
import { Box, Typography } from "@mui/material";

const legendItems = [
  { label: "Idle", src: endpointPath(`/iconForMap?size=${2}&n150=${0}&n300=${0}&n600=${0}`) },
  { label: "2x75", src: endpointPath(`/iconForMap?size=${6}&n150=${1}&n300=${0}&n600=${0}`) },
  { label: "2x150", src: endpointPath(`/iconForMap?size=${6}&n150=${0}&n300=${1}&n600=${0}`) },
  { label: "2x300", src: endpointPath(`/iconForMap?size=${6}&n150=${0}&n300=${0}&n600=${1}`) },
];

const Legend = () => {
  return (
    <Box position="absolute" top={20} left={20} sx={{backgroundColor: '#9999ffaa', px:1}} display="flex" flexDirection="column">
      {legendItems.map(({ label, src }) => (
        <Box key={label} display="flex" gap="10px" alignItems="center">
          <Box width="20px" display="flex" alignItems="center">
            <img src={src} alt="" />
          </Box>
          <Typography>{label}</Typography>
        </Box>
      ))}
    </Box>
  )
}

export default memo((props) => {
  const { getAccessTokenSilently } = useAuth();
  const [locations, setLocations] = useState([]);


  useEffect(() => {
    const loadData = async () => {
      const data = await fetchWithToken(
        getAccessTokenSilently,
        "/mapData"
      );
      setLocations(data.map(v => {
        const r = Math.round(Math.sqrt(v.numRuns) * 4) + 2;
        const url = endpointPath(`/iconForMap?size=${r}&n150=${v.n150}&n300=${v.n300}&n600=${v.n600}`);
        return (
          {
            location: `${v.lat}, ${v.lon}`,
            iconSrc: url,
            tooltip: {
              text: v.tenant,
            }
          })
      }
      ))
    }
    loadData();
  }, [])


  // const { getAccessTokenSilently, fetchWithToken } = useAuth();
  // const [dispositions, setDispositions] = useState([]);

  // useEffect(() => {
  //   fetchWithToken(getAccessTokenSilently, "/dispositions").then((resp) =>
  //     setDispositions(resp)
  //   );
  // }, [getAccessTokenSilently]);


  return (
    <>
      <div style={{ display: "flex", flexDirection: 'column', height: "100%", background: 'white' }}>
        <Map
          defaultCenter="40.7061, -73.9969"
          defaultZoom={3}
          height="calc(100vh - 20px)"
          width="100%"
          // provider="bing"
          apiKey="AIzaSyBsbjyww1pLMBNpntQJal1Grq7Tp2Z05pE"
          type="roadmap"
          markers={locations}
        // markerIconSrc= "http://localhost:4123/api/iconForMap?size=5" // "https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/maps/map-marker.png" // "https://www.elementbiosciences.com/uploads/home/hero/home-hero-on-v6.png" // "https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/maps/map-marker.png"
        // apiKey="AiG1c-Al3Uj27H4GsV5Ey8RU-soLkerlOtJ6PlF4IAh6fqLyv9tLo1nCDGIzsQHn" // "Av18NtQIlTqzZ4wLJYjcuC6Fm_hP9BIoTCG1iIBMV9rsQGph9SG4lrii10jC2bGS" // 
        >
        </Map>

        <Legend />
      </div>
    </>
  );
});
